import { render, staticRenderFns } from "./org_detail.vue?vue&type=template&id=74bf2e94&scoped=true&"
import script from "./org_detail.vue?vue&type=script&lang=js&"
export * from "./org_detail.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./org_detail.vue?vue&type=style&index=0&id=74bf2e94&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "74bf2e94",
  "81ba216e"
  
)

export default component.exports